var map = {
	"./404/404.jpg": 4247,
	"./about/about.jpg": 9305,
	"./about/image_1.jpg": 6469,
	"./about/image_2.jpg": 5587,
	"./about/image_3.jpg": 2376,
	"./about/image_4.jpg": 7369,
	"./contacts/contacts.jpg": 1716,
	"./gallery/gallery.jpg": 9246,
	"./home/home.jpg": 9925,
	"./home/services/service_1.jpg": 6211,
	"./home/services/service_2.jpg": 4300,
	"./home/services/service_3.jpg": 1200,
	"./home/services/service_4.jpg": 8341,
	"./home/services/service_5.jpg": 1914,
	"./home/services/service_6.jpg": 9905,
	"./home/services/service_7.jpg": 7699,
	"./home/services/service_8.jpg": 2469,
	"./opportunities/opportunities.jpg": 2143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1810;